import axios from "axios";
import { ONBOARDING_URL } from "@/utils/http-common.js";

class CalculatorService {
  static getToken() {
    return localStorage.getItem("appUserToken");
  }

  static async logisticsCost(data) {
    try {
      const token = this.getToken();
      const response = await axios.post(
        `${ONBOARDING_URL}/calculations/logistics-cost`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async ippFirstMonthPayment(data) {
    try {
      const token = this.getToken();
      const response = await axios.post(
        `${ONBOARDING_URL}/calculations/ipp-first-payment`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async installationCost(data) {
    try {
      const token = this.getToken();
      const response = await axios.post(
        `${ONBOARDING_URL}/calculations/installation-cost`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async metrics(data) {
    try {
      const token = this.getToken();
      const response = await axios.post(
        `${ONBOARDING_URL}/calculations/metrics`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async locationOrStateMetrics(data) {
    try {
      const token = this.getToken();
      const response = await axios.post(
        `${ONBOARDING_URL}/calculations/singup-metrics`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async downPaymentAmount(data) {
    try {
      const token = this.getToken();
      const response = await axios.post(
        `${ONBOARDING_URL}/calculations/down-payment`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  static async upfrontPayment(data) {
    try {
      const token = this.getToken();
      const response = await axios.post(
        // `${ONBOARDING_URL}/logistics-cost`,
        `${ONBOARDING_URL}/calculations/total-upfront-payment`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  static async monthlyPayment(data) {
    try {
      const token = this.getToken();
      const response = await axios.post(
        // `${ONBOARDING_URL}/logistics-cost`,
        `${ONBOARDING_URL}/calculations/monthly-payment`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  static async uploadContract(data) {
    try {
      const token = this.getToken();
      const response = await axios.post(
        `${ONBOARDING_URL}/kycfiles/filesapi-file`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

export default CalculatorService;



// WEBPACK FOOTER //
// ./src/services/calculator.js